import webworkify from 'webworkify-webpack'

/**
 * Creates worker
 *
 * @return {WebWorker}
 * @private
 */
export default function () {
  return Promise.resolve(webworkify(require.resolve('./worker-wrapper')))
}
